/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CarFinderSm = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 49 30" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M11.63 6.75l2.81 2.59 2.81-2.6a1.93 1.93 0 0 0 0-2.77 2 2 0 0 0-2.81 0A2 2 0 0 0 13 3.4a2 2 0 0 0-1.37.6 1.94 1.94 0 0 0 0 2.75zM10.19 2.55l1.41-1.12a.74.74 0 0 0 0-1.18 1.14 1.14 0 0 0-1.41 0 1.12 1.12 0 0 0-.7-.25 1.05 1.05 0 0 0-.7.25.74.74 0 0 0 0 1.18zM16.56 2.55l1.06-.74a.48.48 0 0 0 0-.8 1 1 0 0 0-1.06 0 .94.94 0 0 0-1 0 .48.48 0 0 0 0 .8z" fill={secondaryColor} /><path d="M7.93 29.3A18.11 18.11 0 0 1 12 17.9l3 2.56a14.32 14.32 0 0 0-3.11 8.84h2a12.39 12.39 0 0 1 2.64-7.54l3 2.57a8.47 8.47 0 0 0-1.65 5h2A6.5 6.5 0 0 1 21 25.62l3 2.6a2.82 2.82 0 0 0-.22 1.08h5.95a2.94 2.94 0 0 0-3-2.9 3 3 0 0 0-1.43.37L10.62 14.1l.59-3.53L5.6 5.1 4.2 9.2 0 10.57l5.6 5.48 3.64-.58s0 .06.06.08l1.24 1.07A20 20 0 0 0 6 29.3h2zm.19-16.08l-2.26.37-2.46-2.46 1.09-.37.88-.29.3-.88.33-1.1L8.49 11zM35.67 29.3a8.83 8.83 0 0 0-8.92-8.71 9 9 0 0 0-1.37.13 1 1 0 0 0-.82 1.11 1 1 0 0 0 1.13.8 7.47 7.47 0 0 1 1.06-.11 6.87 6.87 0 0 1 6.94 6.78h2z" /><path d="M41.62 29.3a14.71 14.71 0 0 0-14.87-14.52 15 15 0 0 0-6.69 1.57 1 1 0 0 0-.44 1.3 1 1 0 0 0 1.34.42 13 13 0 0 1 5.79-1.35A12.75 12.75 0 0 1 39.64 29.3h2z" /><path d="M47.56 29.3A20.59 20.59 0 0 0 26.75 9a21.07 21.07 0 0 0-11.4 3.33 1 1 0 0 0-.28 1.34 1 1 0 0 0 1.37.28 19.08 19.08 0 0 1 10.31-3A18.63 18.63 0 0 1 45.58 29.3h2z" />
      </g>
    </svg>
  </span>
);

CarFinderSm.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CarFinderSm.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CarFinderSm;
